import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div />;
  if (user) {
    const to = (location.state && location.state.from && location.state.from.pathname) || '/';
    return <Navigate to={to} replace />;
  }
  return children;
}